'use client';
import React, { useEffect, useState } from 'react';
import SaneksLogo from './SaneksLogo';

// Шапка перенесена с ses-rb.ru (ses-rb-site/): разметка, ссылки и SVG 1-в-1,
// Bootstrap-сетка и offcanvas заменены на Tailwind + React-состояние.
// Брейкпоинт 992px соответствует Bootstrap lg.

const SITE = 'https://ses-rb.ru';
const MESSENGER_TEXT = encodeURIComponent('Добрый день, пишу Вам с сайта ses-rb.ru , хочу узнать о вашем приложении');
const WHATSAPP_URL = `https://wa.me/79093491193?text=${MESSENGER_TEXT}`;
const TELEGRAM_URL = `https://t.me/SaneksIT?text=${MESSENGER_TEXT}`;
const SIGNIN_URL = `${SITE}/signin/`;
const PHONE = '+7 (347) 286-28-12';
const PHONE_HREF = 'tel:+73472862812';

const functionLinks = [
  { name: 'Проверки по чек-листам', href: `${SITE}/proverki-po-chek-listam/` },
  { name: 'Заполнение журналов', href: `${SITE}/zapolnenie-zhurnalov/` },
  { name: 'Контроллеры', href: 'https://controller.ses-rb.ru/' },
  { name: 'Производственный контроль', href: `${SITE}/proizvodstvennyy-kontrol/` },
  { name: 'Пест-контроль', href: `${SITE}/pest-kontrol/` },
  { name: 'Контроль медосмотров', href: `${SITE}/kontrol-medosmotrov/` },
];

const navLinks = [
  { name: 'Цены', href: `${SITE}/tseny/` },
  { name: 'О нас', href: `${SITE}/o-nas/` },
  { name: 'Контакты', href: `${SITE}/kontakty/` },
];

const linkClass = 'text-[#072643] hover:text-[#17C6A6] transition-all duration-300';
// Как .f-21.lh-25 на ses-rb.ru: до 768px шрифт уменьшается до 18px/22px
const mobileLinkClass = `${linkClass} text-[18px] leading-[22px] min-[769px]:text-[21px] min-[769px]:leading-[25px]`;

const ArrowIcon = () => (
  <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L4.5 4L8 1" stroke="#072643" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.3825 8.09354C27.1469 -0.000267552 16.4576 -2.40654 8.16796 2.62475C0.0964503 7.65604 -2.52134 18.5936 2.71424 26.6874L3.15053 27.3437L1.40534 33.9062L7.94981 32.1562L8.60426 32.5937C11.4402 34.125 14.4943 35 17.5484 35C20.8206 35 24.0928 34.125 26.9288 32.375C35.0003 27.1249 37.3999 16.4061 32.3825 8.09354ZM27.8014 24.9374C26.9288 26.2499 25.838 27.1249 24.311 27.3437C23.4384 27.3437 22.3476 27.7812 17.9847 26.0312C14.2761 24.2812 11.222 21.4374 9.04055 18.1561C7.73166 16.6249 7.07721 14.6561 6.85907 12.6873C6.85907 10.9373 7.51351 9.40606 8.60426 8.3123C9.04055 7.87479 9.47685 7.65604 9.91315 7.65604H11.0039C11.4402 7.65604 11.8765 7.65604 12.0946 8.53105C12.5309 9.62481 13.6217 12.2498 13.6217 12.4686C13.8398 12.6873 13.8398 13.1248 13.6217 13.3436C13.8398 13.7811 13.6217 14.2186 13.4035 14.4373C13.1854 14.6561 12.9672 15.0936 12.7491 15.3123C12.3128 15.5311 12.0946 15.9686 12.3128 16.4061C13.1854 17.7186 14.2761 19.0311 15.3669 20.1249C16.6758 21.2186 17.9847 22.0937 19.5117 22.7499C19.948 22.9687 20.3843 22.9687 20.6024 22.5312C20.8206 22.0937 21.9113 20.9999 22.3476 20.5624C22.7839 20.1249 23.0021 20.1249 23.4384 20.3436L26.9288 22.0937C27.3651 22.3124 27.8014 22.5312 28.0195 22.7499C28.2377 23.4062 28.2377 24.2812 27.8014 24.9374Z" fill="#17C6A6" />
  </svg>
);

const TelegramIcon = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 0C7.8321 0 0 7.83323 0 17.5C0 27.1668 7.83323 35 17.5 35C27.1679 35 35 27.1668 35 17.5C35 7.83323 27.1668 0 17.5 0ZM26.0953 11.9892L23.2231 25.524C23.0108 26.4837 22.4395 26.7163 21.6424 26.2647L17.2674 23.0402L15.1573 25.0724C14.9247 25.305 14.7271 25.5026 14.2755 25.5026L14.586 21.0497L22.6935 13.7245C23.0469 13.414 22.6156 13.2379 22.1494 13.5484L12.1292 19.8563L7.81065 18.5082C6.87242 18.2124 6.85097 17.57 8.00823 17.1184L24.8805 10.6118C25.664 10.3295 26.3482 10.8026 26.0942 11.9881L26.0953 11.9892Z" fill="#17C6A6" />
  </svg>
);

const AccountIcon = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17.5" cy="17.5" r="17.5" fill="#17C6A6" />
    <path d="M8.15625 26.5642V23.6892C8.15625 19.8655 14.3815 17.9392 17.5 17.9392C20.6185 17.9392 26.8437 19.8655 26.8437 23.6892V26.5642M17.5 16.5017C18.4951 16.5017 19.4678 16.2066 20.2952 15.6538C21.1226 15.101 21.7675 14.3152 22.1483 13.3958C22.5291 12.4765 22.6287 11.4649 22.4346 10.4889C22.2404 9.51295 21.7613 8.61646 21.0576 7.91283C20.354 7.2092 19.4575 6.73002 18.4815 6.53589C17.5056 6.34175 16.494 6.44139 15.5746 6.82219C14.6553 7.203 13.8695 7.84786 13.3167 8.67525C12.7638 9.50263 12.4687 10.4754 12.4687 11.4705C12.4687 12.8048 12.9988 14.0845 13.9424 15.0281C14.8859 15.9716 16.1656 16.5017 17.5 16.5017Z" stroke="white" />
    <path d="M16 18L16.5 19L17.5 19.5L18.5 19L19 18" stroke="white" />
    <path d="M17 19L16 25L17.5 26.5L19 25L18 19" stroke="white" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.78487 14.9735C9.5957 14.943 9.4058 14.9162 9.21808 14.8806C8.44617 14.7347 7.73877 14.4247 7.07196 14.0189C6.02753 13.383 5.13603 12.5656 4.31629 11.6662C3.47988 10.7479 2.71957 9.7715 2.12088 8.67825C1.67876 7.86956 1.34028 7.0224 1.21127 6.10336C1.06776 5.07544 1.18952 4.08818 1.69978 3.16915C1.96868 2.68495 2.31948 2.26899 2.75436 1.92417C2.96165 1.76011 3.15444 1.57645 3.36173 1.41239C3.80023 1.0654 4.27425 1.08354 4.66709 1.48498C4.89178 1.71438 5.09979 1.96628 5.27882 2.23269C5.6144 2.72996 5.96012 3.22504 6.15727 3.80143C6.36094 4.3967 6.28048 4.92808 5.79777 5.36001C5.55424 5.57852 5.30926 5.79993 5.04108 5.98504C4.4685 6.3814 4.38659 6.86922 4.60258 7.49643C4.80118 8.07355 5.14908 8.56645 5.52162 9.03903C6.00869 9.6568 6.52909 10.2463 7.14082 10.7457C7.47929 11.0216 7.83517 11.2706 8.2715 11.3715C8.65274 11.46 8.97745 11.3613 9.25939 11.0927C9.53916 10.827 9.81603 10.557 10.1096 10.308C10.5901 9.90144 11.1199 9.8891 11.665 10.1671C11.844 10.2586 12.023 10.3581 12.1803 10.4829C12.7428 10.9286 13.3211 11.3584 13.7538 11.9435C14.1119 12.4277 14.0836 12.8952 13.6401 13.2995C13.2102 13.6915 12.8029 14.1133 12.2876 14.4029C11.7599 14.6991 11.2011 14.8886 10.5988 14.9474C10.5597 14.951 10.5213 14.9641 10.4821 14.9728C10.2516 14.9735 10.0183 14.9735 9.78487 14.9735Z" stroke="white" />
  </svg>
);

const BurgerIcon = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="5" width="16" height="1.6" fill="white" />
    <rect y="0.200195" width="16" height="1.6" fill="white" />
    <rect y="9.7998" width="16" height="1.6" fill="white" />
  </svg>
);

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2L14 14M14 2L2 14" stroke="#000" strokeWidth="2" />
  </svg>
);

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [functionsOpen, setFunctionsOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  return (
    <>
      <header className="bg-white font-suisse font-normal subpixel-antialiased">
        <div className="mx-auto w-full px-3 py-4 min-[576px]:max-w-[540px] min-[768px]:max-w-[720px] min-[992px]:max-w-[960px] min-[1200px]:max-w-[1140px] min-[1400px]:max-w-[1320px]">
          <div className="flex items-center justify-between gap-6">
            <a href={`${SITE}/`} className="block shrink-0">
              <SaneksLogo width={152} height={40} />
            </a>

            {/* Меню (desktop) */}
            <ul className="hidden min-[992px]:flex items-center gap-10 m-0 p-0 list-none">
              <li className="group relative flex items-center">
                <span className={`${linkClass} text-[18px] leading-[25px] cursor-default`}>Функции</span>
                <div className="ms-1 transition-all duration-300 group-hover:rotate-180 group-hover:-translate-y-[3px]">
                  <ArrowIcon />
                </div>
                <ul className="absolute left-0 top-5 z-20 min-w-[290px] rounded-[20px] bg-white px-2.5 py-5 list-none m-0 shadow-[2px_4px_20px_rgba(186,207,247,0.3)] opacity-0 invisible transition-all duration-300 group-hover:opacity-100 group-hover:visible space-y-2.5">
                  {functionLinks.map((link) => (
                    <li key={link.href}>
                      <a className={`${linkClass} text-[18px] leading-[25px]`} href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </li>
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a className={`${linkClass} text-[18px] leading-[25px]`} href={link.href}>{link.name}</a>
                </li>
              ))}
            </ul>

            {/* Контакты (desktop) */}
            <div className="hidden min-[992px]:flex items-center">
              <a className="me-4" href={WHATSAPP_URL} target="_blank" rel="nofollow noopener" aria-label="WhatsApp">
                <WhatsAppIcon />
              </a>
              <a className="me-4" href={TELEGRAM_URL} target="_blank" rel="nofollow noopener" aria-label="Telegram">
                <TelegramIcon />
              </a>
              <div className="me-4 rounded-full bg-[#17C6A6] px-6 py-1">
                <a className="text-white hover:text-[#072643] transition-all duration-300 text-[18px] leading-[25px] whitespace-nowrap" href={PHONE_HREF}>{PHONE}</a>
              </div>
              <a href={SIGNIN_URL} rel="nofollow" aria-label="Личный кабинет">
                <AccountIcon />
              </a>
            </div>

            {/* Кнопки (mobile) */}
            <div className="flex min-[992px]:hidden items-center">
              <a className="me-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#17C6A6]" href={PHONE_HREF} aria-label="Позвонить">
                <PhoneIcon />
              </a>
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-[#17C6A6] cursor-pointer"
                onClick={() => setMenuOpen(true)}
                aria-label="Открыть меню"
                aria-expanded={menuOpen}
                aria-controls="mobMenuOpen"
              >
                <BurgerIcon />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Мобильное меню (offcanvas) */}
      <div
        className={`fixed inset-0 z-[1040] bg-black/50 transition-opacity duration-300 min-[992px]:hidden ${menuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
      <div
        id="mobMenuOpen"
        className={`font-suisse font-normal subpixel-antialiased fixed inset-y-0 left-0 z-[1045] flex w-[400px] max-w-full flex-col bg-white text-[#072643] transition-transform duration-300 min-[992px]:hidden ${menuOpen ? 'translate-x-0' : '-translate-x-full invisible'}`}
        role="dialog"
        aria-modal="true"
        aria-label="Меню"
      >
        <div className="flex items-center justify-between p-4">
          <a href={`${SITE}/`} className="block" onClick={() => setMenuOpen(false)}>
            <SaneksLogo width={124} height={32} />
          </a>
          <button
            type="button"
            className="p-2 opacity-50 hover:opacity-75 cursor-pointer"
            onClick={() => setMenuOpen(false)}
            aria-label="Закрыть меню"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <ul className="flex flex-col m-0 p-0 list-none">
            <li className="mb-4 flex flex-col items-start">
              <button
                type="button"
                className="flex items-center cursor-pointer"
                onClick={() => setFunctionsOpen((v) => !v)}
                aria-expanded={functionsOpen}
              >
                <span className={mobileLinkClass}>Функции</span>
                <span className="ms-1"><ArrowIcon /></span>
              </button>
              <div className={`grid transition-[grid-template-rows] duration-300 ${functionsOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <ul className="overflow-hidden m-0 p-0 list-none">
                  {functionLinks.map((link, idx) => (
                    <li key={link.href} className={`mb-4 ${idx === 0 ? 'mt-4' : ''}`}>
                      <a className={mobileLinkClass} href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
            {navLinks.map((link) => (
              <li key={link.href} className="mb-4">
                <a className={mobileLinkClass} href={link.href}>{link.name}</a>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-6 py-2">
            <a href={WHATSAPP_URL} target="_blank" rel="nofollow noopener" aria-label="WhatsApp">
              <WhatsAppIcon />
            </a>
            <a href={TELEGRAM_URL} target="_blank" rel="nofollow noopener" aria-label="Telegram">
              <TelegramIcon />
            </a>
            <a href={SIGNIN_URL} rel="nofollow" aria-label="Личный кабинет">
              <AccountIcon />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
